import { defineMessages } from "react-intl";

export const team24AdBannerConfluencei18n = defineMessages({
    team24LogoAlt: {
        id: "team-24-ad-banner.confluence.team-24-logo.alt",
        defaultMessage: "team 24 logo"
    },
    adCopyTitle: {
        id: "team-24-ad-banner.confluence.ad-copy.title",
        defaultMessage: "Our annual conference is back in Las Vegas!"
    },
    adCopyParagraph: {
        id: "team-24-ad-banner.confluence.ad-copy.paragraph",
        defaultMessage:
            "Be the first to know about product updates coming to Confluence at our biggest conference of the year, Team ’24."
    },
    callToActionText: {
        id: "team-24-ad-banner.confluence.call-to-action.text",
        defaultMessage: "Register now"
    },
    callToActionIconLabel: {
        id: "team-24-ad-banner.confluence.call-to-action.icon.label",
        defaultMessage: "right arrow icon"
    },
    rightHandImageAlt: {
        id: "team-24-ad-banner.confluence.right-hand-image.alt",
        defaultMessage: "team 24 shapes"
    }
});
